<div class="main-container mat-app-background">
  <lfw-navigation-toolbar>
    <ng-container navStart>
      <div class="hide-gt-mobile">
        <button mat-icon-button (click)="sidenav().toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="pwa-back-button">
        <button mat-icon-button (click)="navigateBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
    </ng-container>
    <ng-container navCenter>
      <div class="navbuttons hide-lt-mobile">
        @for (mitem of availableItems$ | async; track mitem.id) {
          <div [class.active-link]="rla.isActive">
            <a
              class="topbutton"
              mat-button
              [routerLink]="mitem.route"
              routerLinkActive="active"
              #rla="routerLinkActive"
              [matTooltipTouchGestures]="'off'"
              [matTooltip]="showToolTip() ? mitem.text : ''">
              <mat-icon>{{ mitem.icon }}</mat-icon>
              <span class="hide-lt-tablet">&nbsp;{{ mitem.text }}</span>
            </a>
          </div>
        }
        @if (menuService.cmdUser) {
          <lfw-menu [menuItems]="userCommands$ | async">
            <a
              routerLinkActive="active"
              class="topbutton"
              mat-button
              [matTooltip]="showToolTip() ? menuService.cmdUser.text : ''">
              <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
              <span class="hide-lt-tablet">&nbsp;{{ menuService.cmdUser.text }}</span>
            </a>
          </lfw-menu>
        }
      </div>
    </ng-container>
  </lfw-navigation-toolbar>

  <mat-sidenav-container>
    @if (isMenuVisible) {
      <mat-sidenav color="primary" #sidenav mode="over" opened="false" fxHide.gt-xs="true">
        <mat-nav-list>
          @for (mitem of availableItems$ | async; track mitem.id) {
            <div>
              <a mat-list-item [routerLink]="mitem.route" routerLinkActive="active-link">
                <mat-icon>{{ mitem.icon }}</mat-icon>
                <span>&nbsp;{{ mitem.text }}</span>
              </a>
            </div>
          }
          <lfw-menu [menuItems]="userCommands$ | async">
            @if (menuService.cmdUser) {
              <a mat-list-item>
                <mat-icon>{{ menuService.cmdUser.icon }}</mat-icon>
                <span>&nbsp;{{ menuService.cmdUser.text }}</span>
              </a>
            }
          </lfw-menu>
        </mat-nav-list>
      </mat-sidenav>
    }

    <mat-sidenav-content class="sidenav-content">
      <div class="main-outlet-container">
        <ng-content />
      </div>

      @if (isInfoBarVisible) {
        <mat-toolbar class="secondary bottombar" color="secondary">
          <mat-icon class="bar-icon">person</mat-icon>
          <div class="bottomtext">{{ userName }}</div>
          @if (hasProjectName) {
            <mat-icon class="bar-icon">local_library</mat-icon>
            <div class="bottomtext">{{ projectName }}</div>
          }
          @if (hasInfoText) {
            <mat-icon class="bar-icon">info</mat-icon>
            <div class="bottomtext">{{ infoText }}</div>
          }
          <span class="spacer"></span>
          <div class="bottomtext">{{ shortVersion }}</div>
        </mat-toolbar>
      }
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
